import { StoreMapWrapStyled } from './StoreMap.style';
import { StoreMapMarkerIcon } from './StoreMapMarkerIcon';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import L from 'leaflet';
import { FC, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { useShopsysSelector } from 'redux/main';

type StoreMapMarker = {
    locationLatitude: number | null;
    locationLongitude: number | null;
};

type StoreMapProps = {
    lat?: number | null;
    lng?: number | null;
    zoom?: number | null;
    markers?: StoreMapMarker[];
    activeMarkerHandler?: (index: number) => void;
    isDetail?: boolean;
    closeMarkers?: boolean;
};

const TEST_IDENTIFIER = 'basic-StoreMap';

export const StoreMap: FC<StoreMapProps> = ({
    lat,
    lng,
    zoom,
    markers,
    activeMarkerHandler,
    isDetail,
    closeMarkers,
}) => {
    const { mapSetting } = useShopsysSelector((state) => state.domain);
    const isMobile = useMediaMin('vl');

    const mapLat = lat === null || lat === undefined ? mapSetting.latitude : lat;
    const mapLng = lng === null || lng === undefined ? mapSetting.longitude : lng;
    const mapZoom = zoom === null || zoom === undefined ? mapSetting.zoom : zoom;
    const [activeMarker, setActiveMarker] = useState(-1);

    const markerClickHandler = (index: number) => {
        if (!isDetail) {
            setActiveMarker(activeMarker === index ? -1 : index);
        }
    };

    useEffect(() => {
        if (closeMarkers) {
            setActiveMarker(-1);
        }
    }, [closeMarkers]);

    useEffect(() => {
        if (activeMarkerHandler) {
            activeMarkerHandler(activeMarker);
        }
    }, [activeMarkerHandler, activeMarker]);

    return (
        <StoreMapWrapStyled data-testid={TEST_IDENTIFIER}>
            <MapContainer
                center={[mapLat, mapLng] as [number, number]}
                zoom={mapZoom}
                scrollWheelZoom={true}
                style={{ height: '100%' }}
            >
                <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MarkerClusterGroup
                    chunkedLoading
                    iconCreateFunction={(cluster: any) => {
                        return L.divIcon({
                            html: `<div class="flex bg-white rounded-full font-bold size-10 items-center justify-center border-4 border-primary text-sm text-primary shadow-none lg:h-12 lg:w-12 lg:text-base">${cluster.getChildCount()}×</div>`,
                            className: 'custom-cluster-icon-wrapper', // Avoid default marker styling
                            iconSize: isMobile ? L.point(40, 40, true) : L.point(48, 48, true),
                        });
                    }}
                >
                    {markers !== undefined &&
                        Array.isArray(markers) &&
                        markers.length !== 0 &&
                        markers.map((marker, index) => (
                            <Marker
                                key={index}
                                position={[marker.locationLatitude ?? 0, marker.locationLongitude ?? 0]}
                                eventHandlers={{
                                    click: () => markerClickHandler(index),
                                }}
                                icon={
                                    new L.DivIcon({
                                        html: ReactDOMServer.renderToString(
                                            <StoreMapMarkerIcon
                                                isActive={activeMarker === index || isDetail}
                                                isClickable={!!markerClickHandler}
                                            />,
                                        ),
                                        iconSize: [40, 40],
                                        className: 'custom-marker-icon', // Avoid default marker styling
                                    })
                                }
                            ></Marker>
                        ))}
                </MarkerClusterGroup>
            </MapContainer>
        </StoreMapWrapStyled>
    );
};
